import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Alert, Container, Row, Col, Card } from "react-bootstrap";
import api from "../../api/axios";
import logo1 from "../../assets/logo/logo-login.png";
import "../../styles/form.css";

const RegisterForm = () => {
  const [form, setForm] = useState({
    business_name: "",
    admin_name: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const { business_name, admin_name, email, password } = form;
    if (!business_name || !admin_name || !email || !password) {
      setError("Todos los campos son obligatorios.");
      return;
    }

    if (!validateEmail(email)) {
      setError("El email no tiene un formato valido.");
      return;
    }

    try {
      setLoading(true);
      const res = await api.post("/register", form);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      localStorage.setItem("business", JSON.stringify(res.data.business));
      navigate(`/admin/${res.data.business.slug}`);
    } catch (err) {
      setError(err.response?.data?.message || "Error en el registro");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card className="shadow-lg login-card register-card">
              <Card.Body className="p-5">
                <div className="text-center mb-4">
                  <img
                    src={logo1}
                    alt="Logo qrBenefits"
                    style={{ maxWidth: "120px" }}
                    className="mb-3"
                  />
                  <h3 className="mb-1">Crear cuenta</h3>
                  <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                    Registra tu negocio, prueba 30 dias gratis y luego continua por USD 10/mes.
                  </p>
                </div>

                {error && (
                  <Alert variant="danger" className="py-2">
                    {error}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="business_name">
                    <Form.Label>Nombre del negocio</Form.Label>
                    <Form.Control
                      type="text"
                      name="business_name"
                      placeholder="Ej: Cafeteria La Esquina"
                      value={form.business_name}
                      onChange={handleChange}
                      disabled={loading}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="admin_name">
                    <Form.Label>Tu nombre</Form.Label>
                    <Form.Control
                      type="text"
                      name="admin_name"
                      placeholder="Ej: Juan Perez"
                      value={form.admin_name}
                      onChange={handleChange}
                      disabled={loading}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>Email de acceso</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="tucorreo@ejemplo.com"
                      value={form.email}
                      onChange={handleChange}
                      disabled={loading}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="password">
                    <Form.Label>Contrasena</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Ingresa una contrasena segura"
                      value={form.password}
                      onChange={handleChange}
                      disabled={loading}
                      required
                    />
                  </Form.Group>

                  <Button type="submit" className="w-100 btn-qr-primary" disabled={loading}>
                    {loading ? "Creando cuenta..." : "Crear cuenta"}
                  </Button>
                </Form>

                <div className="text-center mt-3">
                  <small className="text-muted">
                    Ya tienes una cuenta?{" "}
                    <button
                      type="button"
                      className="btn btn-link p-0 text-qr-primary"
                      onClick={() => navigate("/login")}
                      disabled={loading}
                    >
                      Inicia sesion
                    </button>
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default RegisterForm;
